/** Download a table as an Excel sheet (exceljs is loaded only when someone downloads). */
export interface ReportColumn<Row> {
	header: string;
	key: keyof Row & string;
	width?: number;
}

export async function downloadSheet<Row extends Record<string, string | number | null>>(
	fileName: string,
	sheetName: string,
	columns: ReportColumn<Row>[],
	rows: Row[]
): Promise<void> {
	const [{ default: ExcelJS }, { saveAs }] = await Promise.all([import("exceljs"), import("file-saver")]);
	const workbook = new ExcelJS.Workbook();
	const sheet = workbook.addWorksheet(sheetName.slice(0, 31));
	sheet.columns = columns.map((c) => ({ header: c.header, key: c.key, width: c.width ?? 16 }));
	rows.forEach((row) => sheet.addRow(row));
	sheet.getRow(1).font = { bold: true };
	sheet.views = [{ state: "frozen", ySplit: 1 }];
	const buffer = await workbook.xlsx.writeBuffer();
	saveAs(new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), fileName);
}
